import { createSlice } from '@reduxjs/toolkit';
import { addNewLedger, editLedger, getAllLedgers, getLedgerById } from './ledgersService';

const initialState = {
  allLedgers: {
    isLedgersLoading: null,
    isLedgersSuccess: null,
    ledgersMessage: null,
    pageCount: 0,
    ledgers: [],
  },

  newLedger: {
    isLedgerCreating: null,
    isLedgerCreated: null,
    ledgerCreationMsg: null,
  },

  editedLedger: {
    isEditingLedger: null,
    isLedgerEdited: null,
    ledgerEditedMsg: null
  },

  ledgerDetails: {
    isLedgerLoading: null,
    isLedgerSuccess: null,
    ledger: null
  }
};

const ledgersSlice = createSlice({
  name: 'ledger',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllLedgers.pending, (state) => {
        state.allLedgers = {
          ...initialState.allLedgers, // Reset to initial state
          isLedgersLoading: true,
          ledgersMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllLedgers.rejected, (state, action) => {
        state.allLedgers = {
          ...initialState.allLedgers,
          isLedgersLoading: false,
          isLedgersSuccess: false,
          ledgersMessage: action.payload || 'Error occurred while fetching ledgers',
        };
      })

      // FULFILLED
      .addCase(getAllLedgers.fulfilled, (state, action) => {
        state.allLedgers = {
          ...initialState.allLedgers,
          isLedgersLoading: false,
          isLedgersSuccess: true,
          pageCount: action.payload.pageCount || 0,
          ledgers: action.payload.data || [],
        };
      });

    //Ledger creating
    builder
      .addCase(addNewLedger.pending, (state) => {
        state.newLedger = {
          ...initialState.newLedger, // Reset to initial state
          isLedgerCreating: true,
          ledgerCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewLedger.rejected, (state, action) => {
        state.newLedger = {
          ...initialState.newLedger,
          isLedgerCreating: false,
          isLedgerCreated: false,
          ledgerCreationMsg: action.payload || 'Error occurred while creating the ledger.',
        };
      })

      // FULFILLED
      .addCase(addNewLedger.fulfilled, (state, action) => {
        state.newLedger = {
          ...initialState.newLedger,
          isLedgerCreating: false,
          isLedgerCreated: true,
          ledgerCreationMsg: action.payload || 'Successfully created the ledger.',
        };
      });

    //Ledger editing
    builder
      .addCase(editLedger.pending, (state) => {
        state.editedLedger = {
          ...initialState.editedLedger, 
          isEditingLedger: true,
          ledgerEditedMsg: 'Loading',
        };
      })

      .addCase(editLedger.rejected, (state, action) => {
        state.editedLedger = {
          ...initialState.editedLedger,
          isEditingLedger: false,
          isLedgerEdited: false,
          ledgerEditedMsg: action.payload || 'Error occurred while editing the ledger.',
        };
      })

      .addCase(editLedger.fulfilled, (state, action) => {
        state.editedLedger = {
          ...initialState.editedLedger,
          isEditingLedger: false,
          isLedgerEdited: true,
          ledgerEditedMsg: action.payload || 'Successfully edited the ledger.',
        };
      });

       //Ledger details
    builder
    .addCase(getLedgerById.pending, (state) => {
      state.ledgerDetails = {
        ...initialState.ledgerDetails, 
        isLedgerLoading: true,
      };
    })

    .addCase(getLedgerById.rejected, (state, action) => {
      state.ledgerDetails = {
        ...initialState.ledgerDetails,
        isLedgerLoading: false,
        isLedgerSuccess: false,
      };
    })

    .addCase(getLedgerById.fulfilled, (state, action) => {
      state.ledgerDetails = {
        ...initialState.ledgerDetails,
        isLedgerLoading: false,
        isLedgerSuccess: true,
        ledger: action.payload,
      };
    });
  },
});

export default ledgersSlice.reducer;
